export default __webpack_public_path__ + "static/media/exemploNonograma.a1c08261.png";